// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__3P4Kx","rowsWrapper":"style_rowsWrapper__okO7e","rowWrapper":"style_rowWrapper__27API"};